import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { StudentMapMenu } from "./MapMenu/MapMenu";
import { MobileMap } from "./MobMap";
import { MapMenuStatic } from "./MapMenuStatic/MapMenuStatic";
import "./Map.css";
import { useGetQuests } from "../../../../hooks/student/quest/useGetQuests";
import { useTranslation } from "react-i18next";
import { loadStudentMapI18n } from "../../../i18n/loaders/student.i18n";
import { useI18nLoader } from "../../../i18n/loaders/useI18nLoader";
import { usePreviewQuests } from "../../../../hooks/web/usePreviewQuests";
import { AuthModal } from "../../../common/AuthV2/AuthModal";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import NavigateToAddStudentPopup from "../../../common/AuthV2/NavigateToAddStudentPopup";

export const StudentAdminMap = () => {
  const { t } = useTranslation("student-map");
  const navigate = useNavigate();
  const { user } = useAuth();
  const { student } = useAuthStudent();
  const currentUser = user?.user || student?.student;
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalView, setAuthModalView] = useState("options");
  const [selectedQuestId, setSelectedQuestId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  const [selectedQuestImage, setSelectedQuestImage] = useState(null);
  const i18nReady = useI18nLoader(loadStudentMapI18n);
  const { userType } = useOutletContext();
  const { fetchPreview, data, loading, error: newError } = usePreviewQuests();
  const { quests, error, getQuests } = useGetQuests();
  const isQuestAssigned = (questId) => {
    const quest = quests.find((q) => q.id === questId);
    return quest?.student_assigned && quest?.school_assigned;
  };
  const isAssignedBhagat = isQuestAssigned(1);
  const isAssignedGandhi = isQuestAssigned(6);
  const isAssignedShiva = isQuestAssigned(11);
  const isAssignedHanuman = isQuestAssigned(5);
  const isAssignedKrishna = isQuestAssigned(3);
  const isAssignedMurugan = isQuestAssigned(2);
  const isAssignedQueenJhansi = isQuestAssigned(7);
  const isAssignedRiseMaratha = isQuestAssigned(8);
  const isAssignedNetaji = isQuestAssigned(9);
  const isAssignedParshuram = isQuestAssigned(4);

  const QUEST_ICONS = {
    1: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    2: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    3: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    4: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    5: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    6: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    7: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    8: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    9: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
    11: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/map/Popup+image.png",
  };
  const isSubscribed =
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed;

  const getPreviewById = (id) => {
    return data.find((item) => item.id === id);
  };

  const shouldShowLock = (id) => {
    if (loading) return false;

    const item = getPreviewById(id);

    if (!item) return true;

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    if (isSubscribed) return false;

    return !item.has_free_preview;
  };

  const handleQuestClick = (e, questId) => {
    e.preventDefault();

    if (loading || !data.length) {
      return; // or show loader / toast
    }

    const item = getPreviewById(questId);
    const isFree = item?.has_free_preview;

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    const questImage = QUEST_ICONS[questId];

    if (!currentUser) {
      localStorage.setItem(
        "redirectAfterLogin",
        JSON.stringify({
          questId: questId,
          isFree: isFree ?? false,
          isSubscribed: isSubscribed ?? false,
        }),
      );

      setAuthModalView("options");
      setShowAuthModal(true);
      return;
    }

    if (!isFree && !isSubscribed) {
      setSelectedQuestId(questId);
      setSelectedQuestImage(questImage);
      setShowAddStudentModal(true);
      return;
    }

    navigate(`/student/admin/episodes/${questId}`);
  };

  useEffect(() => {
    if (userType === "school-student") {
      getQuests("quest");
    }
  }, []);

  useEffect(() => {
    fetchPreview("quest"); // or "festive"
  }, []);

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  if (!i18nReady) return null; // or loader

  return (
    <section>
      <div className="container mob-dnone">
        <div className="row">
          <div className="col-md-12">
            <div>
              <div className="text-center mt-4">
                <p className="QuestMapCard-Titl">{t("title")}</p>
                <p className="QuestMapCard-Para">{t("subtitle")}</p>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="QuestMapCardMF">
              <div className="QuestMapShiv">
                <img
                  className="img-fluid"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiv.png"
                  alt=""
                />
                {userType === "school-student" ? (
                  <Link
                    to={isAssignedShiva ? "/student/admin/episodes/11" : "#"}
                  >
                    <img
                      className={`img-fluid QuestMapShivName zoom-in-zoom-out ${
                        isAssignedShiva ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiv-name.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapShivIcn ${
                        isAssignedShiva ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiva-icn.png"
                      alt=""
                    />
                    <img
                      className="img-fluid QuestMapShivCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiv-e1.png"
                      alt=""
                    />
                  </Link>
                ) : (
                  <Link
                    to="/student/admin/episodes/11"
                    onClick={(e) => handleQuestClick(e, 11)}
                  >
                    <img
                      className="img-fluid QuestMapShivName zoom-in-zoom-out"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiv-name.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapShivIcn ${
                        shouldShowLock(11) ? "blackgrayscale" : ""
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiva-icn.png"
                      alt=""
                    />
                    <img
                      className="img-fluid QuestMapShivCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiv-e1.png"
                      alt=""
                    />
                    {shouldShowLock(11) && (
                      <img
                        className="QuestMapShivLock"
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                        alt=""
                      />
                    )}
                  </Link>
                )}
              </div>

              <div className="QuestMapMountain">
                <img
                  className="img-fluid QuestMapShivMountain"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/mountain.png"
                  alt=""
                />
              </div>

              <div className="QuestMapHanuman">
                {userType === "school-student" ? (
                  <Link
                    to={isAssignedHanuman ? "/student/admin/episodes/5" : "#"}
                  >
                    <img
                      className="img-fluid QuestMapHanumanCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-cut.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapHanumanName zoom-in-zoom-out ${
                        isAssignedHanuman ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-name.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapHanumanIcn ${
                        isAssignedHanuman ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-icn.png"
                      alt=""
                    />
                  </Link>
                ) : (
                  <Link
                    to="/student/admin/episodes/5"
                    onClick={(e) => handleQuestClick(e, 5)}
                  >
                    <img
                      className="img-fluid QuestMapHanumanCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-cut.png"
                      alt=""
                    />
                    <img
                      className="img-fluid QuestMapHanumanName zoom-in-zoom-out"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-name.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapHanumanIcn ${
                        shouldShowLock(5) ? "blackgrayscale" : ""
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-icn.png"
                      alt=""
                    />

                    {/* 🔒 Lock */}
                    {shouldShowLock(5) && (
                      <img
                        className="QuestMapHanumanLock"
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                        alt=""
                      />
                    )}
                  </Link>
                )}
                <img
                  className="img-fluid QuestMapHanumanLand"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman.png"
                  alt=""
                />
                <div className="QuestHanumanTrainSmoke">
                  <img
                    src="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExeTQ2OHpkeDFtYmt6ZWw4M2wxaDh2NHZkZXZ3NmV4dG9yMXpuZWptaiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/kgg8SmIYRvn7UyRVrR/giphy.gif"
                    alt=""
                  />
                </div>
              </div>

              <div className="QuestMapQueen">
                <img
                  className="img-fluid QuestMapQueenLand"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen.png"
                  alt=""
                />
                {userType === "school-student" ? (
                  <Link
                    to={isAssignedGandhi ? "/student/admin/episodes/6" : "#"}
                  >
                    <img
                      className={`img-fluid QuestMapGandhiCut`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-cut.png"
                      alt=""
                    />
                    {/* <img
                      className={`img-fluid QuestMapGandhiIcn ${
                        isAssignedGandhi ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-icn.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapGandhiName zoom-in-zoom-out ${
                        isAssignedGandhi ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-name.png"
                      alt=""
                    /> */}
                  </Link>
                ) : (
                  <Link to="/student/admin/episodes/6">
                    <img
                      className="img-fluid QuestMapGandhiCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-cut.png"
                      alt=""
                    />

                    {/* <img
                      className="img-fluid QuestMapGandhiIcn"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-icn.png"
                      alt=""
                    />
                    <img
                      className="img-fluid QuestMapGandhiName zoom-in-zoom-out"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-name.png"
                      alt=""
                    /> */}
                  </Link>
                )}

                {userType === "school-student" ? (
                  <Link
                    to={
                      isAssignedQueenJhansi ? "/student/admin/episodes/7" : "#"
                    }
                  >
                    <img
                      className="img-fluid QuestMapQueenCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-cut.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapQueenIcn ${
                        isAssignedQueenJhansi ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-icn.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapQueenName zoom-in-zoom-out ${
                        isAssignedQueenJhansi ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-name.png"
                      alt=""
                    />
                  </Link>
                ) : (
                  <Link
                    to="/student/admin/episodes/7"
                    onClick={(e) => handleQuestClick(e, 7)}
                  >
                    <img
                      className="img-fluid QuestMapQueenCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-cut.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapQueenIcn ${
                        shouldShowLock(7) ? "blackgrayscale" : ""
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-icn.png"
                      alt=""
                    />
                    <img
                      className="img-fluid QuestMapQueenName zoom-in-zoom-out"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-name.png"
                      alt=""
                    />
                    {shouldShowLock(7) && (
                      <img
                        className="QuestMapQueenLock"
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                        alt=""
                      />
                    )}
                  </Link>
                )}

                {userType === "school-student" ? (
                  <Link
                    to={isAssignedNetaji ? "/student/admin/episodes/9" : "#"}
                  >
                    <img
                      className="img-fluid QuestMapBoseCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-cut.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapBoseIcn ${
                        isAssignedNetaji ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-icn.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapBoseName zoom-in-zoom-out ${
                        isAssignedNetaji ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-name.png"
                      alt=""
                    />
                  </Link>
                ) : (
                  <Link
                    to="/student/admin/episodes/9"
                    onClick={(e) => handleQuestClick(e, 9)}
                  >
                    <img
                      className="img-fluid QuestMapBoseCut"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-cut.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapBoseIcn ${
                        shouldShowLock(9) ? "blackgrayscale" : ""
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-icn.png"
                      alt=""
                    />
                    <img
                      className="img-fluid QuestMapBoseName zoom-in-zoom-out"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-name.png"
                      alt=""
                    />
                    {shouldShowLock(9) && (
                      <img
                        className="QuestMapBoseLock"
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                        alt=""
                      />
                    )}
                  </Link>
                )}

                {userType === "school-student" ? (
                  <Link
                    to={isAssignedBhagat ? "/student/admin/episodes/1" : "#"}
                  >
                    <img
                      className={`img-fluid QuestMapBhagatSinghIcn ${
                        isAssignedBhagat ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-icn.png"
                      alt=""
                    />
                    <img
                      className={`img-fluid QuestMapBhagatSinghName zoom-in-zoom-out ${
                        isAssignedBhagat ? "" : "grayscale"
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-name.png"
                      alt=""
                    />
                  </Link>
                ) : (
                  <Link
                    to="/student/admin/episodes/1"
                    onClick={(e) => handleQuestClick(e, 1)}
                  >
                    <img
                      className={`img-fluid QuestMapBhagatSinghIcn ${
                        shouldShowLock(1) ? "blackgrayscale" : ""
                      }`}
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-icn.png"
                      alt=""
                    />
                    <img
                      className="img-fluid QuestMapBhagatSinghName zoom-in-zoom-out"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-name.png"
                      alt=""
                    />
                    {shouldShowLock(1) && (
                      <img
                        className="QuestMapBhagatSinghLock"
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                        alt=""
                      />
                    )}
                  </Link>
                )}
              </div>
            </div>

            <div className="QuestMapMaratha">
              <img
                className="img-fluid QuestMapMarathaLand"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji.png"
                alt=""
              />
              {userType === "school-student" ? (
                <Link
                  to={isAssignedRiseMaratha ? "/student/admin/episodes/8" : "#"}
                >
                  <img
                    className={`img-fluid QuestMapShivajiCut`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapShivajiIcn ${
                      isAssignedRiseMaratha ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-icn.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapShivajiName zoom-in-zoom-out ${
                      isAssignedRiseMaratha ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-name.png"
                    alt=""
                  />
                </Link>
              ) : (
                <Link
                  to="/student/admin/episodes/8"
                  onClick={(e) => handleQuestClick(e, 8)}
                >
                  <img
                    className="img-fluid QuestMapShivajiCut"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapShivajiIcn ${
                      shouldShowLock(8) ? "blackgrayscale" : ""
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-icn.png"
                    alt=""
                  />
                  <img
                    className="img-fluid QuestMapShivajiName zoom-in-zoom-out"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-name.png"
                    alt=""
                  />
                  {shouldShowLock(8) && (
                    <img
                      className="QuestMapShivajiLock"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                      alt=""
                    />
                  )}
                </Link>
              )}
            </div>

            <div className="QuestMapKrishna">
              <img
                className="img-fluid MapKrishna"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna.png"
                alt=""
              />
              {userType === "school-student" ? (
                <Link
                  to={isAssignedKrishna ? "/student/admin/episodes/3" : "#"}
                >
                  <img
                    className="img-fluid MapKrishnaCut"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid KrishnaIcn ${
                      isAssignedKrishna ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-icn.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid KrishnaName zoom-in-zoom-out ${
                      isAssignedKrishna ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-name.png"
                    alt=""
                  />
                </Link>
              ) : (
                <Link
                  to="/student/admin/episodes/3"
                  onClick={(e) => handleQuestClick(e, 3)}
                >
                  <img
                    className="img-fluid MapKrishnaCut"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid KrishnaIcn ${
                      shouldShowLock(3) ? "blackgrayscale" : ""
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-icn.png"
                    alt=""
                  />
                  <img
                    className="img-fluid KrishnaName zoom-in-zoom-out"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-name.png"
                    alt=""
                  />
                  {shouldShowLock(3) && (
                    <img
                      className="KrishnaIcnLock"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                      alt=""
                    />
                  )}
                </Link>
              )}

              {userType === "school-student" ? (
                <Link
                  to={isAssignedMurugan ? "/student/admin/episodes/2" : "#"}
                >
                  <img
                    className="img-fluid MapMurganCut"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapMruganIcn ${
                      isAssignedMurugan ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-icn.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapMruganName zoom-in-zoom-out ${
                      isAssignedMurugan ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-name.png"
                    alt=""
                  />
                </Link>
              ) : (
                <Link
                  to="/student/admin/episodes/2"
                  onClick={(e) => handleQuestClick(e, 2)}
                >
                  <img
                    className="img-fluid MapMurganCut"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapMruganIcn ${
                      shouldShowLock(2) ? "blackgrayscale" : ""
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-icn.png"
                    alt=""
                  />
                  <img
                    className="img-fluid QuestMapMruganName zoom-in-zoom-out"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-name.png"
                    alt=""
                  />
                  {shouldShowLock(2) && (
                    <img
                      className="QuestMapMruganIcnLock"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                      alt=""
                    />
                  )}
                </Link>
              )}

              <div>
                <img
                  className="QuestMapRiverElemFirst"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/rv1.png"
                  alt=""
                />
                <img
                  className="QuestMapRiverElemSecond"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/rv2.png"
                  alt=""
                />
                <img
                  className="QuestMapRiverElemThree"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/rv3.png"
                  alt=""
                />
                <img
                  className="QuestMapRiverElemFour"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/rv4.png"
                  alt=""
                />
              </div>

              <div>
                <img
                  className="QuestMapBoatFirst"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/boatfirst.png"
                  alt=""
                />
                <img
                  className="QuestMapBoatSecond"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/boatsecond.png"
                  alt=""
                />
              </div>
            </div>

            <div className="QuestMapForest">
              <img
                className="img-fluid QuestMapForestLand"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram.png"
                alt=""
              />
              <img
                className="img-fluid QuestMapForestTree"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/tree.png"
                alt=""
              />
              {userType === "school-student" ? (
                <Link
                  to={isAssignedParshuram ? "/student/admin/episodes/4" : "#"}
                >
                  <img
                    className="img-fluid QuestMapParshuramCut"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/purshuram-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapParshuramIcn ${
                      isAssignedParshuram ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-icn.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapParshuramName zoom-in-zoom-out ${
                      isAssignedParshuram ? "" : "grayscale"
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-name.png"
                    alt=""
                  />
                </Link>
              ) : (
                <Link
                  to="/student/admin/episodes/4"
                  onClick={(e) => handleQuestClick(e, 4)}
                >
                  <img
                    className="img-fluid QuestMapParshuramCut"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/purshuram-cut.png"
                    alt=""
                  />
                  <img
                    className={`img-fluid QuestMapParshuramIcn ${
                      shouldShowLock(4) ? "blackgrayscale" : ""
                    }`}
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-icn.png"
                    alt=""
                  />
                  <img
                    className="img-fluid QuestMapParshuramName zoom-in-zoom-out"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-name.png"
                    alt=""
                  />
                  {shouldShowLock(4) && (
                    <img
                      className="QuestMapParshuramIcnLock"
                      src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                      alt=""
                    />
                  )}
                </Link>
              )}
            </div>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 9999 }}>
          <MapMenuStatic />
        </div>
      </div>

      <div className="dsktop-dnone container-fluid">
        <MobileMap
          userType={userType}
          isAssignedBhagat={isAssignedBhagat}
          isAssignedShiva={isAssignedShiva}
          isAssignedGandhi={isAssignedGandhi}
          isAssignedHanuman={isAssignedHanuman}
          isAssignedRiseMaratha={isAssignedRiseMaratha}
          isAssignedKrishna={isAssignedKrishna}
          isAssignedMurugan={isAssignedMurugan}
          isAssignedNetaji={isAssignedNetaji}
          isAssignedParshuram={isAssignedParshuram}
          isAssignedQueenJhansi={isAssignedQueenJhansi}
        />
        <div style={{ position: "relative", zIndex: 9999 }}>
          <StudentMapMenu />
        </div>
      </div>

      {/* Login Modal */}
      <AuthModal
        show={showAuthModal}
        onHide={() => setShowAuthModal(false)}
        defaultView={authModalView}
      />

      {/* NavigateToAddStudentPopup Modal */}
      <NavigateToAddStudentPopup
        modalTitle="UNLOCK QUEST!"
        showModal={showAddStudentModal}
        handleClose={() => setShowAddStudentModal(false)}
        questImage={selectedQuestImage}
      />
    </section>
  );
};
